"use client";
import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faFolder } from "@fortawesome/free-regular-svg-icons";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { useSidebarContext } from "../../Context";
import CollapsedSubMenuList from "./CollapsedSubMenuList";
import SidebarTooltip from "./SidebarTooltip";
import SubMenuList from "./SubMenuList";
import styles from "../menu.module.css";

const SidebarMenuItem = ({
  label = "Menu",
  icon = faFolder,
  onClick = () => {},
  children = [],
  activeMenu = "",
  anchorEl = null,
  setAnchorE1 = () => {},
  url = "/",
}) => {
  const { pathname } = useLocation();
  const { isSidebarCollapsed } = useSidebarContext();

  const hasSubMenu = Array.isArray(children) && children.length > 0;
  const isSubMenuActive = hasSubMenu && activeMenu === label;
  const isDashboard = label === "Dashboard";

  const linkUrl = isDashboard ? "/" : url;

  const handleClick = (e) => {
    onClick(e);
    if (hasSubMenu && isSidebarCollapsed) {
      setAnchorE1(e.currentTarget);
    }
  };

  const handleClose = () => setAnchorE1(null);

  const renderChevron = () =>
    hasSubMenu && (
      <FontAwesomeIcon
        icon={faChevronDown}
        className={`${styles.chev_icon} ${
          isSubMenuActive ? styles.chev_icon_open : ""
        }`}
      />
    );

  const RenderMenuLabel = () => {
    const isDashboardActive = isDashboard && pathname == "/";

    const isMenuItemActive =
      (!hasSubMenu && pathname == url) || isDashboardActive;

    const hasActiveMenuItem = children.some((item) => item.url === pathname);

    const activeMenuItemClass =
      hasActiveMenuItem || isMenuItemActive ? styles.activeMenuItem : "";

    return (
      <h3
        tabIndex={0}
        className={`${styles.menu_item} ${
          isSubMenuActive ? styles.active : ""
        } ${
          isSidebarCollapsed ? styles.collapsed : ""
        } ${activeMenuItemClass} `}
        onClick={handleClick}
        onKeyDown={(e) => e.key === "Enter" && handleClick(e)}
      >
        <FontAwesomeIcon className={styles.menu_icon} icon={icon} />
        {!isSidebarCollapsed && (
          <>
            {label}
            {renderChevron()}
          </>
        )}
      </h3>
    );
  };

  const renderSubMenu = () => {
    if (!isSubMenuActive) return null;
    return isSidebarCollapsed ? (
      <CollapsedSubMenuList
        anchorEl={anchorEl}
        onClose={handleClose}
        items={children}
      />
    ) : (
      <SubMenuList items={children} />
    );
  };

  return (
    <div className={styles.menu_item_container}>
      <SidebarTooltip label={label}>
        {hasSubMenu ? (
          RenderMenuLabel()
        ) : (
          <Link to={linkUrl}> {RenderMenuLabel()}</Link>
        )}
      </SidebarTooltip>
      {renderSubMenu()}
    </div>
  );
};

export default SidebarMenuItem;
